export default __webpack_public_path__ + "static/media/roll-model-starter-skit.38852439.svg";